import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, signal, WritableSignal } from '@angular/core';
import { PlCalendarEvent } from '@shared/services/lifemap/lifemap.service';
import { BlockLifemap } from '@shared/models/step.model';
import { LifemapEntryData } from '@app/components/blocks/block-lifemap/editLifemapEntry/editLifemapEntry.component';
import { TimeFormat } from '@app/components/pl-timepicker/pl-timepicker.component';

export interface ModalEditLifemapEntryInputs {
  event: PlCalendarEvent;
  allActivities: string[];
  blockLifemap: BlockLifemap;
  timeFormat: TimeFormat;
}

@Component({
  selector: 'pl-modal-edit-lifemap-entry',
  templateUrl: './modalEditLifemapEntry.component.html',
})
export class ModalEditLifemapEntryComponent {
  public event!: WritableSignal<PlCalendarEvent>;
  public blockLifemap!: WritableSignal<BlockLifemap>;
  public timeFormat!: WritableSignal<TimeFormat>;
  public allActivities: WritableSignal<string[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalEditLifemapEntryInputs,
    private dialogRef: MatDialogRef<ModalEditLifemapEntryComponent, LifemapEntryData | null | undefined>,
  ) {
    this.event = signal(data.event);
    this.blockLifemap = signal(data.blockLifemap);
    this.timeFormat = signal(data.timeFormat);
    this.allActivities = signal(data.allActivities);
  }

  public discardChangesOnEditEvent(): void {
    this.dialogRef.close(null);
  }

  public saveLifeMapEntry(lifemapEntryData: LifemapEntryData): void {
    this.dialogRef.close(lifemapEntryData);
  }
}
